














import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';

@Component
export default class Textarea extends Vue {
  @Model('change') public value!: any;
  public MAXLEN: number = 2000;
  public contentLen: number = 0;
  public remark: string = '';

  @Watch('value', { immediate: true })
  public resetValue(): void {
    this.remark = this.value;
    this.contentLen = this.remark.length;
  }

  public onTextChange(e: any): void {
    const value = e.target.value;
    if (value.length <= this.MAXLEN) {
      this.contentLen = value.length;
      this.remark = value;
    } else {
      this.remark = value.slice(0, this.MAXLEN);
      this.$message.error(this.$tc('warningTip.remarkInvaild'));
    }
    this.$emit('change', this.remark);
  }
}
